import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ReactLenis } from 'lenis/react';
import { FiAward, FiMapPin, FiGlobe, FiTarget } from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const featuresData = [
  { icon: FiAward, title: "100% NATURAL", desc: "Pure ingredients, no additives, directly from nature." },
  { icon: FiMapPin, title: "SRI LANKAN ORIGIN", desc: "Sourced exclusively from the rich soils of Ceylon." },
  { icon: FiGlobe, title: "EXPORT QUALITY", desc: "Meeting international standards for premium products." },
  { icon: FiTarget, title: "SUSTAINABLY SOURCED", desc: "Ethical practices supporting local communities and environment." }
];

const FeatureCard = ({ i, feature, progress, range, targetScale }) => {
  const container = useRef(null);
  const scale = useTransform(progress, range, [1, targetScale]);

  return (
    <div ref={container} className="h-screen flex items-center justify-center sticky top-0">
      <motion.div 
        style={{ scale, top: `calc(-5vh + ${i * 30}px)` }}
        className="flex flex-col items-center justify-center text-center w-[90vw] md:w-[550px] h-[360px] md:h-[420px] bg-white/80 backdrop-blur-xl border border-white p-8 rounded-3xl shadow-[0_20px_50px_-15px_rgba(0,0,0,0.1)] origin-top relative"
      >
        <div className="w-16 h-16 md:w-20 md:h-20 mb-6 bg-brand-sand/60 rounded-full flex items-center justify-center shadow-inner">
          <SafeIcon icon={feature.icon} className="w-8 h-8 md:w-10 md:h-10 text-brand-gold stroke-[1.5]" />
        </div>
        <h3 className="font-serif text-xl md:text-2xl font-bold text-brand-darkSage mb-3 md:mb-4 uppercase tracking-wider">
          {feature.title}
        </h3>
        <p className="text-brand-lightText text-sm md:text-base leading-relaxed max-w-[280px]">
          {feature.desc}
        </p>
      </motion.div>
    </div>
  );
};

const Features = () => {
  const mainContainer = useRef(null);
  const { scrollYProgress } = useScroll({
    target: mainContainer,
    offset: ["start start", "end end"],
  });

  return (
    <ReactLenis root>
      <section className="relative z-30 bg-brand-sand">
        <div className="pt-32 sm:pt-40 md:pt-48 pb-10 text-center relative z-10 pointer-events-none">
          <h2 className="text-3xl md:text-5xl font-serif text-brand-darkSage">
            WHY CEYLANTHRO
          </h2>
        </div>

        <div ref={mainContainer} className="relative pb-[5vh]">
          {featuresData.map((feature, i) => {
            const targetScale = 1 - (featuresData.length - i - 1) * 0.05;
            const startProgress = i === featuresData.length - 1 ? 0.99 : i * (1 / (featuresData.length - 1));
            return (
              <FeatureCard 
                key={i} 
                i={i} 
                feature={feature} 
                progress={scrollYProgress} 
                range={[startProgress, 1]} 
                targetScale={targetScale} 
              />
            );
          })}
        </div>
      </section>
    </ReactLenis>
  );
};

export default Features;